import _ from 'lodash';
import * as types from '../constants/ActionTypes';
import Page from '../../lib/page';
import i18n from '../../lib/reacti18n';

const exp = Page.getUserExperience();
const label = i18n.message(`smarthelp/contentToggle.content.label.desktop.${exp}`);

function setBreadcrumbItems(items) {
  return {
    type: types.UPDATE_BREADCRUMB,
    payload: items,
  };
}
function updateBreadcrumb(items) {
  return (dispatch) => {
    dispatch(setBreadcrumbItems(items));
  };
}

function updateBreadCrumbFromArticleContent(response) {
  const items = [];
  if (_.startsWith(response.articleId, 'FAQ') || _.startsWith(response.articleId, 'faq')) {
    if (response.breadCrumbPath && response.breadCrumbTitle) {
      const path = response.breadCrumbPath.split('/');
      const title = response.breadCrumbTitle.split('/');
      if (Page.isMobileLayout()) {
        items.push({
          path: `/${exp}/topic/${path[0]}`,
          title: title[1],
          id: path[1],
        });
      } else {
        items.push({
          path: `/${exp}/home`,
          title: label,
          id: path[0],
        }, {
          path: `/${exp}/topic/${path[0]}`,
          title: title[0],
          id: path[0],
        }, {
          path: `/${exp}/topic/${path[0]}`,
          title: title[1],
          id: path[1],
        });
      }
    }
  }

  return {
    type: types.UPDATE_BREADCRUMB,
    payload: items,
  };
}

function resetBreadcrumb() {
  return {
    type: types.RESET_BREADCRUMB,
  };
}
module.exports = {
  updateBreadcrumb,
  updateBreadCrumbFromArticleContent,
  resetBreadcrumb,
};



// WEBPACK FOOTER //
// ./home/actions/action-breadcrumb.js